import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFirestore } from 'firebase/firestore/lite'

const firebaseConfig = {
  apiKey: 'AIzaSyAFNmKAuVgJtJjLQBKARWjlmeuteg8bGUU',
  authDomain: 'myportfolio-d98f9.firebaseapp.com',
  projectId: 'myportfolio-d98f9',
  storageBucket: 'myportfolio-d98f9.appspot.com',
  messagingSenderId: '350095514776',
  appId: '1:350095514776:web:a834db2b82b154e20604ed',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth()
const provider = new GoogleAuthProvider()
export const db = getFirestore(app)
export const storage = getStorage(app)

export const signInWithGoogle = () => signInWithPopup(auth, provider)
